import { FURTHER_READING } from '../lib/links';

export default function Footer() {
  return (
    <footer className="site-footer">
      <h2>Further reading</h2>
      <ul>
        {FURTHER_READING.map((ref) => (
          <li key={ref.url}>
            <a href={ref.url} target="_blank" rel="noreferrer noopener">
              {ref.title}
            </a>
          </li>
        ))}
      </ul>
      <p>
        Everything is computed in your browser — no data leaves the page, and the permalink is the
        only thing that ever encodes your configuration. MIT licensed.
      </p>
    </footer>
  );
}
